import { render } from "./SettingTable.vue?vue&type=template&id=cfef351a&scoped=true&ts=true"
import script from "./SettingTable.vue?vue&type=script&lang=ts"
export * from "./SettingTable.vue?vue&type=script&lang=ts"

import "./SettingTable.vue?vue&type=style&index=0&id=cfef351a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfef351a"]])

export default __exports__